<template>
    <v-row class="mx-0 px-0 my-0 py-0">
        <v-col cols="12" class="mx-0 px-0 match-cards-container" style="display: inline-flex; overflow-x: auto;">
            <v-card
                v-for="(match, index) in matches.filter(element => !element.pending).splice(0, numOfMatchesToShow || matches.filter(element => !element.pending).length)"
                :key="index"
                style="min-width: 250px; background: #232323; border-right: 1px solid teal;"
                :style="size==='large' ? 'min-height: 200px; min-width: 300px;' : ''"
                class="mx-1 py-2 px-2 rounded-0"
                dark
                @click="!match.postponed && !match.pending ? $router.push({ name: 'Match', params: { id: match.id } }) : null"
            >
                <v-row>
                    <v-col cols="12" align="center" style="font-size: 18px;">
                        <v-icon color="teal"> mdi-basketball-hoop </v-icon>
                        <span class="font-weight-bold"> Matchday {{ match.round }}, </span>
                        <span class="font-weight-thin">
                            {{ `${match.league ? match.league.title : ''}, ` + (match.cup? 'Κύπελλο' : (match.phase === 'regular_season' ? 'Regular Season' : 'Play Offs')) }}
                        </span>
                    </v-col>
                </v-row>
                <v-row v-if="!match.postponed && size === 'large'" class="py-0 my-0">
                    <v-col cols="12" align="center" class="py-0 my-0 secondary-font font-weight-thin">
                        <v-icon
                            color="teal"
                        >
                            mdi-calendar-outline
                        </v-icon>
                        {{ getDate(match.matchDatetime) }}
                    </v-col>
                </v-row>
                <v-row align="center" class="my-0 secondary-font">
                    <v-col :cols="match.pending || (match.scoreTeam1 === 0 && match.scoreTeam2 === 0) && !match.postponed ? 4 : 3" align="center" @click.stop="goToTeam(match.team1)">
                        <v-avatar style="border-radius: 10px;" size="30px" color="white">
                            <v-img
                                v-if="match.team1.logo"
                                :src="`${assetsUrl}/${match.team1.logo}`"
                                height="30px"
                                contain
                            />
                            <v-icon v-else style="font-size: 50px;" class="teal--text"> mdi-basketball-hoop </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col v-if="match.postponed" cols="6" align="center" class="pb-0 mb-0" style="font-size: 14px;">
                        <v-icon
                            color="red"
                        >
                            mdi-update
                        </v-icon>
                        Αναβoλή
                    </v-col>
                    <v-col v-else-if="match.pending || (match.scoreTeam1 === 0 && match.scoreTeam2 === 0)" cols="4" align="center" class="grey--text lighten-1 font-weight-bold px-0 rounded">
                        <v-row no-guitters>
                            <v-col cols="4" class="px-0 mx-0" align="center">
                                <v-img
                                    :src="require('@/assets/jersey-teal.png')"
                                    height="30px"
                                    contain
                                />
                            </v-col>
                            <v-col cols="4" class="px-0 mx-0">
                                <span class="mx-1">vs</span>
                            </v-col>
                            <v-col cols="4" class="px-0 mx-0" align="center">
                                <v-img
                                    :src="require('@/assets/jersey-black.png')"
                                    height="30px"
                                    contain
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col v-if="!match.pending && !match.postponed && (match.scoreTeam1 > 0 || match.scoreTeam2 > 0)" cols="3" class="font-weight-bold left-rounded" :class="match.scoreTeam1 > match.scoreTeam2 ? 'winning-score custom-teal' : 'losing-score-left'">
                        <span>{{ match.scoreTeam1 }}</span>
                    </v-col>
                    <v-col v-if="!match.pending && !match.postponed && (match.scoreTeam1 > 0 || match.scoreTeam2 > 0)" cols="3" class="font-weight-bold right-rounded" :class="match.scoreTeam2 > match.scoreTeam1 ? 'winning-score custom-teal' : 'losing-score-right'">
                        <span>{{ match.scoreTeam2 }}</span>
                    </v-col>
                    <v-col :cols="match.pending || (match.scoreTeam1 === 0 && match.scoreTeam2 === 0) && !match.postponed ? 4 : 3" align="center" @click.stop="goToTeam(match.team2)">
                        <v-avatar style="border-radius: 10px;" size="30px" color="white">
                            <v-img
                                v-if="match.team2.logo"
                                :src="`${assetsUrl}/${match.team2.logo}`"
                                height="30px"
                                contain
                            />
                            <v-icon v-else style="font-size: 40px;" class="teal--text"> mdi-basketball-hoop </v-icon>
                        </v-avatar>
                    </v-col>
                </v-row>
                <v-row v-if="size === 'large'" no-gutters align="center" @click.stop="openMap(match.arena)">
                    <v-col cols="12">
                        <v-icon
                            color="teal"
                        >
                            mdi-basketball-hoop
                        </v-icon>
                        {{ match.arena?.name }}
                    </v-col>
                </v-row>
                <v-row v-if="match.videoUrl" align="center" @click.stop="openVideo(match)">
                    <v-col cols="12" class="pt-0 my-0 pb-2">
                        <v-icon
                            color="red"
                            x-large
                        >
                            mdi-youtube
                        </v-icon>
                        Watch on youtube
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import momentTimezone from 'moment-timezone'
    export default {
        props: {
            matches: {
                type: Array,
                default: null
            },
            numOfMatchesToShow: {
                type: Number,
                default: null
            },
            size: {
                type: String,
                default: 'default'
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        created() {
            // this.$nextTick(() => { this.getMatchesAsc() })
        },
        methods: {
            // getMatchesAsc() {
            //     this.matches.sort(function(a, b) {
            //         if (momentTimezone(a.matchDatetime).isAfter(momentTimezone(b.matchDatetime))) {
            //             return 1
            //         } else {
            //             return -1
            //         }
            //     })
            // },
            getDate(date) {
                return momentTimezone(date).tz('Europe/Athens').locale('el-GR').format('dddd DD/MM/y, HH:mm').toString()
            },
            formatMatchArray() {
                const data = []
                let index = 1
                let temp = []
                this.matches.forEach(element => {
                    temp.push(element)
                    if (index % 4 === 0 || index === this.matches.length) {
                        data.push(temp)
                        temp = []
                    }
                    index++
                })
                return data
            },
            openMap(arena) {
                window.open(`https://www.google.com/maps/place/${arena.coordinates}`, '_self', 'noreferrer')
            },
            goToTeam(team) {
                this.$router.push({ name: 'Team', params: { id: team.id } })
            },
            onTouchStart() {
                document.querySelector('body').style.overflow = 'hidden'
            },
            onTouchEnd() {
                document.querySelector('body').style.overflow = 'auto'
            },
            openVideo(match) {
                window.open(match.videoUrl.replace('embed/', 'watch?v='), '_self', 'noreferrer')
            }
        }
    }
</script>

<style>
.v-window__next,
.v-window__prev {
    background: rgba(0, 0, 0, 0);
    margin: 0 -5px;
}

.left-rounded {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

.right-rounded {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}
</style>

<style scoped>

.default-cursor {
    cursor: default;
}

/* Center the cards when they don't fill the row; auto margins keep the
   start of the list reachable when it overflows and scrolls */
.match-cards-container > .v-card:first-child {
    margin-left: auto !important;
}

.match-cards-container > .v-card:last-child {
    margin-right: auto !important;
}

.custom-teal {
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
}

.losing-score-right {
    outline: solid 2px teal;
    outline-offset: -2px;
    color: black;
    background-color: white;
}

.losing-score-left {
    outline: solid 2px teal;
    outline-offset: -2px;
    color: black;
    background-color: white;
}

.winning-score {
    color: white;
}

.custom-date {
    font-weight: 700;
    font-size: 1rem;

    /* border-style: solid; */
    border-radius: 5px;
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    color: white;
}
</style>
